import { Instagram, Mail, Send } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useLang } from "@/i18n/LanguageContext";

const PHOTO_LABELS = {
  es: "Fotografías",
  en: "Photos",
  ru: "Фотографии",
};

export default function Footer() {
  const { t, locale } = useLang();
  const lang = String(locale || "en").toLowerCase().split("-")[0];
  const photosLabel = PHOTO_LABELS[lang] || PHOTO_LABELS.en;

  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-ash/40">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-3 md:px-8">
        <div>
          <div className="flex items-center gap-4">
            <img
              src="/mascot-ghost.png"
              alt=""
              aria-hidden="true"
              data-testid="footer-mascot"
              className="w-14 shrink-0"
            />
            <Logo />
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/45">{t("footer.tagline")}</p>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-white/40">{t("footer.explore")}</p>
          <nav className="mt-4 flex flex-col gap-2.5">
            {[
              { key: "footer.linkParties", href: "/#parties", id: "footer-link-parties" },
              { key: "footer.linkClubs", href: "/#clubs", id: "footer-link-clubs" },
              { key: "footer.linkAbout", href: "/#about", id: "footer-link-about" },
            ].map((l) => (
              <a
                key={l.href}
                data-testid={l.id}
                href={l.href}
                className="w-fit text-sm text-white/55 transition-colors hover:text-flame"
              >
                {t(l.key)}
              </a>
            ))}
            <a
              href="/photos"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-link-photos"
              className="w-fit text-sm text-white/55 transition-colors hover:text-flame"
            >
              {photosLabel}
            </a>
          </nav>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-white/40">{t("footer.findUs")}</p>
          <div className="mt-4 flex flex-col gap-2.5">
            <a
              data-testid="footer-telegram-link"
              href="https://t.me/KNDLA404"
              target="_blank"
              rel="noopener noreferrer"
              className="flex w-fit items-center gap-2 text-sm text-white/55 transition-colors hover:text-flame"
            >
              <Send className="h-4 w-4" /> {t("footer.channel")}
            </a>
            <a
              data-testid="footer-email-link"
              href="mailto:hello@kndla.com"
              className="flex w-fit items-center gap-2 text-sm text-white/55 transition-colors hover:text-flame"
            >
              <Mail className="h-4 w-4" /> hello@kndla.com
            </a>
            <a
              data-testid="footer-instagram-link"
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex w-fit items-center gap-2 text-sm text-white/55 transition-colors hover:text-flame"
            >
              <Instagram className="h-4 w-4" /> Instagram
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/30">{t("footer.rights")}</div>
    </footer>
  );
}
